import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router'
import { Observable, of } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { IUser } from '../../modules/general/users/core/interfaces/IUser'
import {UserService} from "../../modules/general/users/core/services/user.service";

@Injectable({
	providedIn: 'root',
})
export class CurrentUserResolver implements Resolve<IUser | null> {

	constructor(
		private _userService: UserService,
	) {}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IUser | null> {
		const userDetail: IUser | null = this._userService.userDetail$.getValue()
		if (userDetail) return of(userDetail)

		return this._userService.getCurrentUser()
			.pipe(
				catchError((): Observable<null> => of(null)),
			)
	}
}